import { SearchNormal1 } from 'iconsax-react';
import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react';
import CTAButton from '../../components/CTA/CTAButton';
import { cardplotFaqs } from '../Help/HelpData';

function Faq() {
    const [openIndex, setOpenIndex] = useState(null);
    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <>
            <section className='breadcrumb__section bg-overlay help-center-hero faq-page-hero'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h4 className='breadcrumb__text__head'> Frequently Asked Questions </h4>
                                <p className='breadcrumb__text__content color__blue size_pricing'>
                                    Having a tough time? We can help!
                                </p>
                            </div>
                            <div className="position-relative my-3">
                                <form className="help-search-form d-flex align-items-center rounded-pill border px-3 py-1 bg-white mx-auto">
                                    <SearchNormal1 className="me-2" color="#6c757d" />
                                    <input type="search" name="search" placeholder="Search for articles" className="form-control border-0 shadow-none" style={{ flex: 1 }} />
                                    <button type="submit" className="btn btn-dark btn-sm rounded-pill px-3" style={{ backgroundColor: "#2A0A7D"}}> Search </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className='blog__category__container pt-5 pb-5'>
                <div className='container'>
                    <div className='d-flex gap-4 flex-wrap justify-content-center align-items-center '>
                        <div className=' mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Accounts
                                </Link>
                            </div>
                        </div>
                        <div className=' mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Cards
                                </Link>
                            </div>
                        </div>
                        <div className=' mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    New Ghanian Tax Policy
                                </Link>
                            </div>
                        </div>
                        <div className=' mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Malawian currency surge
                                </Link>
                            </div>
                        </div>
                        <div className=' mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Business Accounts
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <section className='help__center__section faq-list-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 my-5'>
                            <h2 className='help__center__section__title'>Cardplot FAQs</h2>
                        </div>
                    </div>
                    <div className='row faq-list'>
                        {cardplotFaqs.map((faq, index) => (
                            <div key={index} className="help__center__section__button">
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className={`d-flex justify-content-between align-items-center text-left ${openIndex === index ? 'button-open' : ''}`}
                                >
                                    <span className="faq-question">{faq.question}</span>
                                    <ChevronDown
                                        className={`chevron-down ${openIndex === index ? 'rotate-180' : ''}`}
                                    />
                                </button>
                                <div className={`accordion-content ${openIndex === index ? 'open' : 'closed'}`}>
                                    <p className="whitespace-pre-line">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <CTAButton />
        </>
    )
}

export default Faq
